class FindationTrigger extends HTMLElement {
    constructor() {
        super()
        this.$button = this.querySelector("button")
        this.$button.disabled = true
        this._initScript()
        this._isReady = false
    }

    get apiKey() {
        return this.getAttribute("api-key")
    }

    get productId() {
        return this.getAttribute("product-id")
    }

    set _isReady(value) {
        this.$button.disabled = !value
    }

    _initScript() {
        if (document.getElementById("findation-widget-script")) this._initWidget()
        else {
            const script = document.createElement("script")
            script.type = "text/javascript"
            script.async = true
            script.id = "findation-widget-script"
            script.onload = () => {
                this._initWidget()
            }
            script.src = "https://assets.findation.com/javascripts/w-adv-13.min.js"
            document.body.appendChild(script)
        }
    }

    _initWidget() {
        window.Findation = window.Findation || {}
        window.Findation.widgetEmbedded = this.widgetEmbedded.bind(this)
        window.Findation.widgetDidOpen = this.widgetDidOpen.bind(this)
        window.Findation.widgetDidClose = this.widgetDidClose.bind(this)
        window.Findation.onSearchComplete = this.onSearchComplete.bind(this)

        window.Findation.init(
            this.$button, 
            this.apiKey, 
            { productId: this.productId }
        )
    }

    _attachListeners() {
        this.$button.addEventListener("click", this.openWidget)
    }

    _detachListeners() {
        this.$button.removeEventListener("click", this.openWidget)
    }

    widgetEmbedded() {
        this._isReady = true
        this.$button.removeAttribute("disabled")
        let iframe = document.getElementById("findation-button-iframe")
        iframe.setAttribute("aria-hidden", "true")
        iframe.classList.add("!tw-hidden")
        this._attachListeners()

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ event: 'findation-widget-embedded' })
    }

    widgetDidOpen() {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ event: 'findation-widget-opened' })
    }

    widgetDidClose() {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ event: 'findation-widget-closed' })
    }

    onSearchComplete(data) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'findation-widget-search-complete',
            'findation-widget-search-complete': {
              countShadesEntered: data.countShadesEntered,
              matchSuccess: data.matchSuccess,
              recommendedShade: data.recommendedShade,
              shadesEntered: data.shadesEntered,
              externalId: data.externalId
            }
          })
  
          if (data.matchSuccess) {
            dataLayer.push({ event: 'findation-widget-recommendation' })
          } else {
            dataLayer.push({ event: 'findation-widget-no-recommendation' })
          }
    }

    openWidget() {
        window.postMessage("overlayOpen")
    }
}

customElements.define('findation-trigger', FindationTrigger)